export const socials = {
    x:"https://x.com/Phoenixbotio",
    tg:'https://t.me/phoenixbot_ai',
    reddit:'https://www.reddit.com/r/phoenixbot_io/s/7uwkDYYyDB',
    medium:'https://medium.com/@phoenixbot.io/',
    tikTok:'https://www.tiktok.com/@phoenixbotio?_t=ZS-8tTeBXqNgHP&_r=1',
    instagram:'https://www.instagram.com/phoenixbotio?igsh=MWZsa2kzazJkYTM3Yg== ',
}